<template>
    <div class="absolute w-full bottom-0 flex justify-center bar-parceiros">
        <img src="/images/parceiros.png" alt="Parceiros" class="w-2/2" />
    </div>
</template>

<style scoped>
@media (min-width: 1440px) and (max-width: 1800px) {
    .bar-parceiros {
        display: none;
    }
}
</style>